import { Container, Stack } from '@chakra-ui/react'
import { ListApiKeys } from '@features/apiKeys/components/ListApiKeys'
import { createFileRoute, useParams } from '@tanstack/react-router'

const ListApiKeyRoute = () => {
  const { orgId } = useParams({ from: '/_auth/orgs/$orgId/apiKeys/' })
  return (
    <Container maxW={'75rem'}>
      <Stack spacing={7}>
        <ListApiKeys orgId={orgId} />
      </Stack>
    </Container>
  )
}

export const Route = createFileRoute('/_auth/orgs/$orgId/apiKeys/')({
  component: ListApiKeyRoute,
  beforeLoad: () => ({ getTitle: () => 'API Keys' }),
})
